import Promise from 'bluebird'
import config from '../config'
import httpRequest from '../httpRequest'

// Admin role must match database role name
const ROLE_ADMIN = 'Admin'
const API = config.api
const ROUTE_USERS = API + '/WedgeUsers/'

export default {
  ROLE_ADMIN,

  fetchUsers () {
    var url = ROUTE_USERS
    url += httpRequest.queryStringWithAuth()
    return httpRequest.get(url)
  },

  fetchUser (id) {
    const queryFilter = '{"include": "roles"}'
    var url = ROUTE_USERS + id
    if (!id) {
      return Promise.reject('id is a required parameter')
    }
    url += httpRequest.queryStringWithAuth({
      filter: queryFilter
    })
    return httpRequest.get(url)
  },

  createUser (user) {
    var url = ROUTE_USERS
    if (!user) {
      return Promise.reject('user is a required parameter')
    }
    url += httpRequest.queryStringWithAuth()
    return httpRequest.post(url, user)
  },

  updateUser (userId, user) {
    var url = ROUTE_USERS + (userId !== '0' ? '/' + userId : '')
    if (userId === '0' || !userId || !user) {
      return Promise.reject('userId and user are a required parameters')
    }
    url += httpRequest.queryStringWithAuth()
    return httpRequest.put(url, user)
  }
}



// WEBPACK FOOTER //
// ./src/lib/apiAdminLib.js